import React from "react";
import { useNavigate } from "react-router-dom";

import { ResourceSchema, ResourceType } from "../data/types";
import { useMemberState } from "../contexts/membercontext";
import { capitalizeString, getDirectLinkFromGoogleDriveSharedLink } from '../utils/helpers';
import { useResourceHook } from "../hooks/resourcehooks";
import {Skeleton} from "../pages/shared/Skeleton";
import { FINANCIAL_WHEEL_OPTIONS, isFinancialIntelligenceResource } from "../utils/fundingPartners";

type ResourceRecordProps = {
  resource: ResourceSchema;
  resourceType: ResourceType
};

const ResourceRecord: React.FC<ResourceRecordProps> = (props) => {
  var navigate = useNavigate();

  var { memberships } = useMemberState()
  var { resource, resourceType  } = props;
  const resourceId = resource.id;

  const openResourceView = () => {
    navigate(`/resources/${resourceType}/${resource.id}`);
  };

  const { updateResourceStatus, isLoading } = useResourceHook({resourceId, resourceType})

  const handleUpdateResourceStatus = async () => {
    if (resourceId && resource){
        await updateResourceStatus(resourceId, resource.active as boolean);
    }
  };

  if (isLoading) { 
    return ( <div className="flex flex-col space-y-3 ">
      <Skeleton className="w-96 h-[350px] rounded-xl" />
      
    </div>)
  } 
  // else {
    return resource ? (
      <div className="font-open-sans grid grid-cols-1 w-96 h-auto bg-white rounded-xl p-2 " >
      <div className="">
        {
          (() => {
            // Backwards compatibility: if bgPhotos exists, use first element; otherwise check bgPhoto (singular)
            const bgPhotoUrl = resource?.bgPhotos?.[0] || resource?.bgPhoto;
            return getDirectLinkFromGoogleDriveSharedLink(bgPhotoUrl) ? (
              <img className='col-span-1 w-96 h-52 rounded-2xl shadow-lg position-absolute object-cover' src={getDirectLinkFromGoogleDriveSharedLink(bgPhotoUrl)} alt={resource?.name} /> 
            ) : (
                <>
                  <div className='w-90 h-52 col-span-1 rounded-2xl position-absolute bg-[#D9D9D9]/70' ></div>
                </>
            );
          })()
        }
      </div>
      
      <span className="flex flex-row w-full">
        <h1 className="text-[20px] font-raleway m-1 text-left font-medium">
          {resource.name}
        </h1>

        <label className="relative w-24 inline-flex items-center cursor-pointer ml-auto scale-80">
          <input
            type="checkbox"
            checked={resource?.active}
            className="sr-only peer"
            onChange={handleUpdateResourceStatus}
          />
          <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[50%] after:translate-y-[-50%] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-primary-400 min-w-[36px] min-h-[20px]"/>
          <span className="ml-2 text-xs font-medium font-open-sans text-gray-400 min-w-[40px]">
            {resource?.active ? "Active" : "Inactive"}
          </span>
        </label>

  
      </span>

      <div className="contain text-left">
        {
          (resource.address || resource.city || resource.state || resource.zipcode) && (
            <p className="text-[#4D4D4D] text-[16px] m-1 font-open-sans">
              {resource.address ? `${resource.address}, `: ``} 
              {resource.city ? `${resource.city}, `: ``} 
              {resource.state ? `${resource.state} `: ``}  
              {resource.zipcode} 
            </p>
          )
        }
        {resourceType === 'funding' && (
          <div className="flex flex-wrap gap-2 m-1">
            <span className="text-xs font-raleway bg-primary-tint text-primary-100 rounded-full px-2.5 py-1">
              {isFinancialIntelligenceResource(resource) ? 'Financial intelligence' : 'Capital'}
            </span>
            {isFinancialIntelligenceResource(resource) ? (
              (resource.funding_profile?.wheels || []).map((wheel) => (
                <span key={wheel} className="text-xs font-raleway bg-primary-tint text-primary-300 rounded-full px-2.5 py-1">
                  {FINANCIAL_WHEEL_OPTIONS.find((option) => option.value === wheel)?.label || wheel}
                </span>
              ))
            ) : (
              typeof resource.total_amount === 'number' && resource.total_amount > 0 ? (
                <span className="text-xs font-raleway bg-[#F5F5F5] rounded-md px-2 py-1">
                  ${resource.total_amount.toLocaleString()}
                </span>
              ) : null
            )}
          </div>
        )}

        <div className="text-[#333333] text-[16px] my-2 m-1 p-1 text-left bg-[#F5F5F5] w-[116px] font-raleway rounded-lg">
          <p className="text-center">{(memberships && memberships.length > 0) ? (memberships.length) : 0} Member{memberships && memberships.length > 1 ? 's' : ''}</p>
        </div>
      </div>
      <div className="flex bg-primary-200 h-20 text-[16px] font-raleway rounded-b-xl  text-white ">
        <button className="mx-auto bg-white text-primary-200 h-10 my-auto rounded-lg p-2 font-semibold"  onClick={openResourceView}>Manage {capitalizeString(resourceType)}</button>
      </div>
    </div>
    ) : (<></>);
  // }
};

export default ResourceRecord;
